import type { CockpitMetricView } from './cockpitViewModel';

type MetricReason = CockpitMetricView['reasonCode'];

export function metricReasonGuidance(
  reason: MetricReason,
): Pick<CockpitMetricView, 'impact' | 'action'> {
  switch (reason) {
    case 'no-usage-observed':
      return {
        impact:
          'Não há base observável para apresentar uma contagem de tokens.',
        action:
          'Confirme se a execução emitiu métricas; não substitua ausência por zero.',
      };
    case 'usage-id-missing':
      return {
        impact:
          'O uso observado não pode ser reconciliado nem somado com segurança.',
        action:
          'Atualize o runtime ou bundle nas próximas execuções; não estime o total manualmente.',
      };
    case 'token-side-not-reported':
      return {
        impact:
          'Somente o lado efetivamente reportado pode ser considerado confiável.',
        action:
          'Verifique a capacidade do provedor para este lado sem completar o valor com zero.',
      };
    case 'time-window-unavailable':
      return {
        impact:
          'Não existe uma janela temporal canônica para interpretar esta duração.',
        action:
          'Aguarde evidência temporal elegível; não calcule a duração pelo relógio do navegador.',
      };
    case 'section-load-failed':
      return {
        impact:
          'A atualização desta métrica falhou e pode não refletir a revisão mais recente.',
        action:
          'Tente atualizar novamente; use o último valor apenas como referência desatualizada.',
      };
    default:
      return { impact: null, action: null };
  }
}

export function metricReasonCause(reason: MetricReason): string | null {
  switch (reason) {
    case 'no-usage-observed':
      return 'Nenhum evento de uso foi observado até o corte desta revisão.';
    case 'usage-id-missing':
      return 'Há evento de uso observado sem identidade estável para reconciliação.';
    case 'token-side-not-reported':
      return 'Este lado da contagem não foi reportado pela fonte observada.';
    case 'time-window-unavailable':
      return 'A janela ainda não possui início e fim elegíveis.';
    case 'section-load-failed':
      return 'A seção de métricas não pôde ser atualizada.';
    default:
      return null;
  }
}
